<template>
  <div class="LmCollapse" :class="{'has-background': background}">
    <div class="Header">
      <lm-icon-button
        class="HeaderButton"
        :icon="resolveIcon"
        :label="title"
        @click="toggle"
      />
      <span v-if="meta" class="Meta">{{ meta }}</span>
    </div>
    <transition name="collapse-transition">
      <div v-if="show" class="Content">
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
import LmIconButton from './LmIconButton'
export default {
  name: 'LmCollapse',
  components: {LmIconButton},
  props: {
    title: {
      type: String,
      required: true
    },
    meta: {
      type: String,
      default: null
    },
    background: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false
    }
  },
  computed: {
    resolveIcon() {
      return this.show ? 'arrow_drop_up' : 'arrow_drop_down'
    }
  },
  methods: {
    toggle() {
      this.show = !this.show
      this.$emit('toggle', this.show)
    },
    open() {
      this.show = true
    },
    close() {
      this.show = false
    }
  }
}
</script>

<style scoped>
.LmCollapse {
  margin: 20px 0 20px -4px; /* -4px = arrow icon offset */
  &.has-background {
    margin: 0 -20px;
    padding: 20px 24px 20px 16px;
    background: theme('colors.gray.200');
    @media (--desktop) {
      margin: 0 -24px;
      padding: 20px;
    }
  }
}
.Header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  .Meta {
    margin-left: 28px;
    color: theme('colors.gray.500');
  }
}
.Content {
  width: 100%;
  margin: 16px 0 0;
  padding-left: 28px;
}
.collapse-transition-enter-active,
.collapse-transition-leave-active {
  transform-origin: top;
  transition: transform 0.2s, opacity 0.2s;
}
.collapse-transition-enter,
.collapse-transition-leave-to {
  opacity: 0;
  transform: scaleY(0.8);
}
</style>

<style>
.LmCollapse {
  .HeaderButton {
    color: theme('colors.gray.700');
    i {
      color: theme('colors.gray.900');
    }
  }
}
</style>
